import { AddCircleOutlineOutlined, Info } from '@mui/icons-material'
import { Button, Card, CardActions, CardContent, CardHeader, Container, CssBaseline, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Tooltip, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, Outlet, useOutletContext } from 'react-router-dom'
import Swal from 'sweetalert2'
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs'
import { AuthStore } from '../../../../store/UserStore'
import { base_url } from '../../../../utils/GlobalVariables'
import { CustomDescrypt } from '../../../../utils/MyEncryption'
import no_data from '../../../../assets/images/no_data.webp'

const Kontrak = () => {
    const [breadcrumbItem, setBreadcrumbItem] = useState({})

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Kontrak" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet context={{ setBreadcrumbItem }} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const Data = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [opd, setOpd] = useState("");
    const [opdData, setOpdData] = useState([])

    useEffect(() => {
        setBreadcrumbItem({ '/verif': 'Home', '': 'Kontrak' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        axios.get(
            base_url + '/get-opd',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                console.log(response);
                const data = response.data;
                setOpdData(data)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                // setTableLoading(false)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const requestKontrak = (params) => {
        // setTableLoading(true)
        axios.get(
            base_url + '/verif/kontrak-opd/' + params,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                console.log(response);
                const data = response.data;
                setTableData(data)
                console.log(tableData.length);
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                // setTableLoading(false)
            })
    }

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    const handleSelectChange = (event) => {
        setOpd(event.target.value)
        requestKontrak(event.target.value)
    }

    return (
        <>
            <Card variant='outlined' sx={{mb: 2}}>
                <CardHeader
                    title="Pilih OPD"
                />
                <CardContent>
                    <Grid container spacing={2} justifyContent='center'>
                        <Grid item xs={12} sm={6} lg={4}>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">OPD</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={opd}
                                    onChange={handleSelectChange}
                                    label="Age"
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {
                                        opdData.map((item) => (
                                            <MenuItem key={item.id_opd} value={item.id_opd}>{item.nm_opd}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {
                opd !== "" &&
                <Card variant='outlined'>
                    <CardHeader
                        title="Data Kontrak"
                    />
                    <CardContent>
                        <Grid container spacing={2}>
                            {
                                tableData.length > 0 ?
                                    tableData.map((item) => (
                                        <Grid item xs={8} md={6} xl={6} key={item.no_kontrak}>
                                            <Card>
                                                <CardContent>
                                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                        {item.tgl_kontrak + "    "}
                                                    </Typography>
                                                    <Typography variant="h5" component="div">
                                                        No. {item.no_kontrak}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                        {item.pekerjaan}
                                                    </Typography>
                                                    <Typography variant="h6">
                                                        {item.nama_perusahaan}
                                                    </Typography>
                                                    <Typography variant="h5">
                                                        Rp. {rP(item.jumlah_kontrak)}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                        Terealisasi Rp. {rP(item.terealisasi)} ({((item.terealisasi / item.jumlah_kontrak) * 100).toFixed(2)}%)
                                                    </Typography>
                                                </CardContent>
                                                <CardActions>
                                                    <Tooltip title="Info">
                                                        <IconButton
                                                            aria-label="confirm"
                                                            color='success'
                                                            component={Link}
                                                            to="/verif/kontrak/detail"
                                                            state={item}
                                                        >
                                                            <Info />
                                                        </IconButton>
                                                    </Tooltip>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    ))
                                    :
                                    <Grid container mt={5} spacing={2} justifyContent="center">
                                        <Grid item lg={6} md={6} sm={12} sx={{ textAlign: "center" }}>
                                            <img
                                                src={no_data}
                                                srcSet={no_data}
                                                alt={"No Data"}
                                                loading="lazy"
                                                sx={{
                                                    objectFit: 'contain',
                                                    padding: "1em 1em 0 1em"
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                            }
                        </Grid>
                    </CardContent>
                </Card>
            }
        </>
    )

}

export { Data as DataKontrak }
export default Kontrak